import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import { Menu, X, Instagram } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <motion.header
      data-testid="main-header"
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'backdrop-blur-xl bg-black/80 border-b border-white/10' : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
    >
      <nav className="px-6 md:px-12 py-5 max-w-7xl mx-auto flex items-center justify-between">
        <motion.a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="cursor-pointer"
          whileHover={{ scale: 1.05 }}
          data-testid="logo-link"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_horological-craft/artifacts/n6ip39w0_logo1.jpg"
            alt="ART TIME Watches"
            className="h-12 md:h-14 w-auto"
          />
        </motion.a>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('colecao')}
            className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider"
            data-testid="nav-collection"
          >
            Coleção
          </button>
          <a
            href="https://auction-arttime.preview.emergentagent.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider"
            data-testid="nav-auction"
          >
            Leilões
          </a>
          <button
            onClick={() => scrollToSection('servicos')}
            className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider"
            data-testid="nav-services"
          >
            Serviços
          </button>
          <button
            onClick={() => scrollToSection('sobre')}
            className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider"
            data-testid="nav-about"
          >
            Sobre
          </button>
          <button
            onClick={() => scrollToSection('contato')}
            className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider"
            data-testid="nav-contact"
          >
            Contato
          </button>
          <a
            href="https://www.instagram.com/arttimewatches/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-[#C9A646] transition-colors duration-300"
            data-testid="nav-instagram"
          >
            <Instagram size={20} />
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden text-white"
          data-testid="mobile-menu-toggle"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <motion.div
          className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          data-testid="mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            <button
              onClick={() => scrollToSection('colecao')}
              className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider text-left"
            >
              Coleção
            </button>
            <a
              href="https://auction-arttime.preview.emergentagent.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider text-left"
            >
              Leilões
            </a>
            <button
              onClick={() => scrollToSection('servicos')}
              className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider text-left"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider text-left"
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-white hover:text-[#C9A646] transition-colors duration-300 font-sans text-sm uppercase tracking-wider text-left"
            >
              Contato
            </button>
            <a
              href="https://www.instagram.com/arttimewatches/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-[#C9A646] transition-colors duration-300 flex items-center gap-2"
            >
              <Instagram size={20} />
              Instagram
            </a>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Header;
